import styled from 'styled-components';

import { MAX_WIDTH } from '../../../../constants';
import { HorizontalCenterBlock } from '../../../../styled';

export const PasswordlessMethodChangeWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-content: center;
`;

export const Wrapper = styled(HorizontalCenterBlock)`
  padding-bottom: 20px;
  flex-direction: column;
  width: ${MAX_WIDTH};
`;

export const Subtitle = styled.h2`
  ${(p) => p.theme.typography.description};
  color: ${(props) => props.theme.colors.muted};
  margin-bottom: 8px;
  text-align: center;
  font-weight: 400;
`;

export const RadioWrapper = styled.div`
  margin-top: 32px;
`;
